import { axiosInstance } from "./axiosInstance";

export const MainProgramService = {
    getAll: async (filter) => {
        return await axiosInstance.get('/api/feature/membership/main-program', { params: filter });
    },
    create: async (data) => {
        return await axiosInstance.post('/api/feature/membership/main-program', data);
    },
    update: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/main-program/update/${id}`, data);
    },
    delete: async (id) => {
        return await axiosInstance.delete(`/api/feature/membership/main-program/delete/${id}`);
    },
    attachDetach: async (id, data) => {
        return await axiosInstance.post(`/api/feature/membership/main-program/attach-detach/${id}`, data);
    },
    replicate: async (id) => {
        return await axiosInstance.post(`/api/feature/membership/main-program/replicate/${id}`);
    },
}